class Column {
	rows: any;

	customClass: any;

	constructor(rows: any[] = []) {
		this.rows = rows;
		this.customClass = null;
	}

	addRow = (row: any) => {
		this.rows.push(row);
		return this;
	};

	getRows = () => this.rows;

	setCustomClass = (customClass: any) => {
		this.customClass = customClass;
		return this;
	};

	getCustomClass = () => this.customClass;
}

export default Column;
